/* eslint-disable camelcase */
import { Divider, Typography } from "@mui/material";
import { Vocabulary } from "../../../Utils/Vocabulary";
import { useState } from "react";
import ExpendButtons from "../../GenericComponents/ExpendButtons";
import { VariantProps } from "./ProductVariants";
import { deleteImagesFromProductVariants } from "../../../Utils/Utils";
import AddImagesToVariants from "./AddImagesToVariants";
import { ProductModel } from "../../../Utils/Models";
import ShowInformationAboutOneVariant from "./ShowInformationAboutOneVariant";
import ProductInformationForEachVariant from "./ProductInformationForEachVariant";

/* eslint-disable @typescript-eslint/no-explicit-any */
type RenderVariantProps = {
  index: number;
  variant: VariantProps;
  product: ProductModel;
  selectedVariants: Array<number>;
  changeOneVariant: (index: number, variant: VariantProps) => void;
  handleChangeSelectedVariants: (index: number) => void;
  handleChangeProduct: (product: ProductModel) => void;
  undoDeleteVariant: (indexes: Array<number>) => void;
};
export default function RenderVariant(props: RenderVariantProps) {
  const {
    index,
    variant,
    product,
    selectedVariants,
    changeOneVariant,
    undoDeleteVariant,
    handleChangeProduct,
    handleChangeSelectedVariants,
  } = props;
  const [openAddImagesModal, setOpenAddImagesModal] = useState(false);
  const [showMore, setShowMore] = useState(false);

  /**
   *
   */
  function handleChangeAddImagesModal() {
    setOpenAddImagesModal(!openAddImagesModal);
  }

  /**
   *
   */
  function handleSaveImages(images: any, files: any, checkedImages: any) {
    const newProduct = Object.assign({}, product);
    newProduct.images = images;
    newProduct.files = newProduct.files
      ? [...newProduct.files, ...files]
      : files;
    newProduct.variants = deleteImagesFromProductVariants(
      images,
      product.variants
    );
    newProduct.variants[index].images = checkedImages.map((index: any) => {
      return images[index];
    });
    handleChangeProduct(newProduct);
    setOpenAddImagesModal(false);
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: 5,
          cursor: variant.mustBeDeleted ? "auto" : "pointer",
        }}
        onClick={() => setShowMore(!showMore)}
      >
        <ProductInformationForEachVariant
          index={index}
          variant={variant}
          selectedVariants={selectedVariants}
          handleChangeSelectedVariants={handleChangeSelectedVariants}
          handleChangeAddImagesModal={handleChangeAddImagesModal}
        />
        {variant.mustBeDeleted ? (
          <p
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography style={{ color: "#999999", fontSize: 15 }}>
              {Vocabulary.deletedVariantMessage}
            </Typography>
            &nbsp; &nbsp;
            <Typography
              color="primary"
              style={{ fontSize: 15, cursor: "pointer" }}
              onClick={() => undoDeleteVariant([index])}
            >
              {Vocabulary.undo}
            </Typography>
          </p>
        ) : (
          <ExpendButtons
            showMore={showMore}
            handleChangeShowMore={() => null}
            style={{ marginLeft: 5 }}
          />
        )}
      </div>
      {variant.mustBeDeleted ? null : (
        <ShowInformationAboutOneVariant
          index={index}
          variant={variant}
          showMore={showMore}
          changeOneVariant={changeOneVariant}
        />
      )}
      <Divider />
      <AddImagesToVariants
        openAddImagesModal={openAddImagesModal}
        product={product}
        variant={variant}
        handleChangeAddImagesModal={handleChangeAddImagesModal}
        handleSaveImages={handleSaveImages}
      />
    </>
  );
}
